// TODO: This file should be cleaned and DRYed up.

import { css } from '@emotion/react';
import { darken, mix, transparentize } from 'polished';
import styled from '@emotion/styled';
import posed from 'react-pose';

export const Shadow = (color, blur = '15px', spread = '5px') => {
  const dervied = transparentize(0.8, darken(0.4, color));

  return css`
    box-shadow: 0 0 ${blur} ${spread} ${dervied};
  `;
};

export const Blend = props =>
  mix(0.7, props.theme.foregroundColor, props.theme.foregroundTextColor);

export const Text = styled.p`
  label: text;

  ${props =>
    props.highlighted
      ? `
    color: ${props.theme.foregroundTextColor};
  `
      : `
    color: ${props.theme.backgroundTextColor};
  `}

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 1.5em;
  font-weight: 600;

  text-align: ${props => props.textAlign || 'left'};

  margin: 0.7em 0;
  padding: 0;
`;

export const ScoreRankText = styled(Text)`
  label: text;

  font-size: 1.2em;
`;

export const Box = styled.div`
  label: box;

  color: ${props => props.theme.backgroundTextColor};

  height: 100%;
  width: 100%;
`;

const AnimatedDiv = posed.div({
  enter: {
    opacity: 1,
    delay: 500,
    transition: {
      duration: 500,
    },
    delayChildren: 500,
    staggerChildren: 500,
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 500,
    },
  },
});

export const PageWrapper = styled(AnimatedDiv)`
  label: page-wrapper;

  position: absolute;
  z-index: 100;

  height: 100%;
  width: 100%;
`;

export const EntriesPageWrapper = styled(posed.div())`
  label: entries-page-wrapper;

  position: absolute;

  height: 100%;
  width: 100%;
`;

export const PopupWrapper = styled(AnimatedDiv)`
  label: popup-wrapper;

  position: absolute;

  z-index: 500;
  height: 100%;
  width: 100%;
`;

export const EntriesBox = styled.div`
  label: entries-box;

  position: absolute;

  height: 90%;
  width: 100%;
`;

export const Grid = styled.div`
  label: grid;

  display: grid;
`;

export const OuterGrid = styled(Grid)`
  label: outer-grid;

  grid-template-columns: 0.3fr 0.7fr 3fr ${props =>
      props.scored ? '0.5fr 0.2fr' : '0.5fr'};

  margin-left: 2em;
  margin-right: 2em;

  align-content: center;
  justify-content: center;

  ${props =>
    props.header
      ? `
    align-items: center;
  `
      : `
  margin-bottom: 0.8em;
  `}

  ${props =>
    props.shadow
      ? `
    filter: drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.1));
  `
      : null}
`;

export const InnerGrid = styled(Grid)`
  label: inner-grid;

  grid-template-columns: repeat(${props => props.columns}, 1fr);

  ${props =>
    props.header
      ? null
      : `
    background-color: ${props.theme.foregroundColor};
    border-radius: 0 20px 20px 0;
  `}
`;

export const Title = styled.h3`
  text-align: ${props => (props.textAlign ? props.textAlign : 'center')};

  font-size: 20px;
  font-weight: normal;

  color: ${props => props.theme.foregroundColor};
`;

export const ScoreTitle = styled(Title)`
  color: ${props => props.theme.foregroundColor};

  background-color: ${props => props.theme.foregroundTextColor};
  border-radius: 10px;

  font-weight: 600;

  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
`;

export const RankTitle = styled(Title)`
  color: ${props => props.theme.foregroundColor};

  background-color: ${props => props.theme.foregroundTextColor};
  border-radius: 10px;

  font-weight: 600;

  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
`;

export const Cell = styled.div`
  label: cell;

  display: grid;
  align-items: center;

  color: ${props =>
    props.header
      ? props.theme.backgroundTextColor
      : props.theme.foregroundTextColor};
`;

export const NameCell = styled(Cell)`
  label: name-cell;

  ${props => (props.header ? 'grid-column: 2 / 2;' : null)}

  background-color: ${({ header, theme: { foregroundColor } }) =>
    header ? null : foregroundColor};
`;

export const QuestionCell = styled(Cell)`
  label: question-cell;
`;

export const ScoreCell = styled(Cell)`
  label: score-cell;

  display: grid;
  grid-template-columns: auto auto;

  margin-left: 10px;
  margin-right: 10px;

  ${props =>
    props.header
      ? null
      : `
    background: linear-gradient(to bottom, ${
      props.theme.foregroundColor
    }, 65%, ${Blend(props)});

    margin-left: 20px;
    margin-right: 20px;
    padding-left: 10px;
    padding-right: 10px;

    ${props => Shadow(props.theme.highlightColor)};

    color: ${props => props.theme.foregroundTextColor};

    font-size: 24px;
    line-height: 24px;

    border-radius: 20px;
  `}
`;

export const RankCell = styled(Cell)`
  label: rank-cell;

  flex-grow: 1;

  ${props =>
    props.sorted
      ? `
    margin-left: 20px;
    margin-right: 20px;
  `
      : null}

  ${props =>
    props.header
      ? null
      : `
    background: linear-gradient(to bottom, ${
      props.theme.foregroundColor
    }, 60%, ${Blend(props)});

    font-size: 24px;
    font-weight: 600;
    line-height: 24px;

    border-radius: 20px;
  `}
`;

export const Avatar = styled.div`
  label: avatar;

  width: 3.5em;

  border-radius: 50%;
  border: 3px solid ${props => props.theme.foregroundTextColor};

  background-image: url(${props => props.src});
  background-color: ${props => props.theme.foregroundTextColor};
  background-size: cover;

  :after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;

export const EntriesWrapper = styled.div`
  label: entries-wrapper;
  display: grid;
`;
